import { render, staticRenderFns } from "./AppWhatsappField.vue?vue&type=template&id=7bca811c&"
import script from "./AppWhatsappField.vue?vue&type=script&lang=js&"
export * from "./AppWhatsappField.vue?vue&type=script&lang=js&"
import style0 from "./AppWhatsappField.vue?vue&type=style&index=0&lang=sass&"
import style1 from "@/assets/style/flags.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VIcon,VList,VListItem,VListItemIcon,VListItemTitle,VMenu})
